<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'AuthPopupLayout',
    data() {
      return {
      }
    },
    created() {
    },
    mounted() {
    },
    computed: {
    },
    methods: {
    }
  }
</script>

<style>

</style>
